import axiosService from './AxiosService';

export class AdminService {
   _resourceName = 'admin';

   async postBackgroundPushMessage(backgroundPushMessage) {
      return await axiosService.create(`/v1.0/${this._resourceName}/send-push-message`, backgroundPushMessage);
   }

   static get instance() { return adminService }
}

const adminService = new AdminService();

export default adminService;
